<template>
	<ul class="uk-grid-match instructions" uk-grid>
		<li class="uk-width-1-3@s">
			<div class="uk-text-left">
				<label>
					<span class="l_title">Количество осей</span>
					<div class="plm">
						<div class="plm__button plm__button--minus" @click="addQnt('-', 'num_axis')"></div>
						<input type="number" readonly v-model="num_axis">
						<div class="plm__button plm__button--plus" @click="addQnt('+', 'num_axis')"></div>
					</div>
				</label>
				<div class="razd"></div>
				<label>
					<div class="l_check">
						<input type="checkbox" class="uk-checkbox" v-model="show_numbers">
						<span>Показывать числа</span>
					</div>
				</label>

				<button class="uk-button uk-button-primary" @click="$parent.commitVal(true, 'start')">СТАРТ!</button>
			</div>
		</li>
		<li class="uk-width-2-3@s">
			<div class="instructions__abacus2">
				<div class="wh-block__pic" style="max-width: 180px;margin: auto;"><img :src="item.inner_image.path" alt=""></div>
			</div>
		</li>
	</ul>
</template>

<script>
  import { mapState, mapMutations } from 'vuex';
  export default {
    name: "instructions",
	  computed:{
      show_numbers: {
        get () {
          return this.$store.state.train.abacus_params.show_numbers
        },
        set (value) {
          this.$parent.commitVal(value, 'show_numbers');
        }
      },
      num_axis: {
        get () {
          return this.$store.state.train.abacus_params.num_axis
        },
        set (value) {
          if(value > 15) value = 15;
          this.$parent.commitVal(value, 'num_axis');
        }
      },
      ...mapState({
        item: 'current_trainer'
      })

	  },
    methods: {
      addQnt(val, param, param2) {
        if (!param2) {
          if (val === '+' && this[param] < 15) {
            this[param]++;
          } else if (this[param] > 1) {
            this[param]--;
          }
        } else {
          if (val === '+') {
            this[param][param2]++;
          } else if (this[param][param2] > 1) {
            this[param][param2]--;
          }
        }
      }
    }
  }
</script>
